const updatedProductsCounts = (productData, orderData) => {
    try {
        // console.log("product data => ", productData);
        // console.log("orderData data => ", orderData);

        return (productData || []).map((product) => {
            const count = orderData.reduce(
                (acc, order) => acc + (order && order?.notes && order?.notes?.length && order?.notes[0]?.id?.includes(product.id) && order?.notes[0]?.productCode === product?.productCode ? 1 : 0),
                0
            );

            return {
                ...product,
                // count: count,
                metadata: { ...product?.metadata, downloads: count }
                // taxonomy: "category",
                // href: category.href as Route,
            };
        });
    } catch (error) {
        console.log("6 : product util : Error in updatedProducts => ", error && error?.message);
    }
}
const calculateAverageRating = (ratings) => {
    // Check if the array is empty
    if (!ratings || ratings.length === 0) {
      return 0;
    }

    // Use reduce to sum the array elements
    const sum = ratings.reduce(
      (accumulator, currentValue) => accumulator + currentValue?.rating,
      0
    );

    // Divide the sum by the total number of ratings
    const average = sum / ratings.length;

    // Optional: Round the result to a specific number of decimal places (e.g., 2)
    return parseFloat(average.toFixed(2));
  };

export { updatedProductsCounts ,calculateAverageRating}